import React from 'react';
import ImageZoom from 'react-medium-image-zoom';

import ProjectHeader from './ProjectHeader';

import coverImg from '../../imgs/Assurant/coverImg-Assurant-Case-Study.png';
import Projects from '../../imgs/Assurant/Projects.png';
import WhatIlearned from '../../imgs/Assurant/Learning.png';
import banner from '../../imgs/Assurant/banner.png';
import Audit from '../../imgs/Assurant/Audit.png';
import Removing from '../../imgs/Assurant/Removing.png';
import Foundations from '../../imgs/Assurant/Foundations.png';
import Color from '../../imgs/Assurant/Color.png';
import Auto from '../../imgs/Assurant/Auto.png';
import Icons from '../../imgs/Assurant/Icons.png';
import Assets from '../../imgs/Assurant/Assets.png';

// const ListInSection = ({ data }) => {
//   return (
//     <ul className="list-in-section">
//       {data.map((item, index) => {
//         return (
//           <li key={index}>
//             <h4>{index + 1}.</h4>
//             <p>
//               <strong>{item.header}</strong>
//             </p>
//             <p>{item.content}</p>
//           </li>
//         );
//       })}
//     </ul>
//   );
// };

const Assurant = () => (
  <div className="caseBody">
    <section className="head">
      <h2>Consistency with Design System and UX Playbook</h2>
      <p className="caseIntro">Assurant</p>
      <img className="img-responsive img-centered" src={coverImg} alt="" />
    </section>
    <section className="mainSec">
      <div className="left">
        <h3 id="overview">Project Overview</h3>
      </div>
      <div className="right">
        <p className="content-p">
          Assurant is a fintech company that offers insurance, service
          contracts, and risk management. Their cross-platform digital products
          offer various services, including online claims filing, policy
          management, and product registration.
        </p>
        <h4>Projects I got to work on</h4>
        <p className="content-p">
          I had the chance to work on the UX playbook and design system and lend
          my help on the PGM (Pocket Geek Mobile) app. I’m honored to lead and
          be a part of such big projects that impacted the entire design
          organization and significantly increased design efficacy and
          effectiveness.
        </p>
        <img className="img-responsive img-centered" src={Projects} alt="" />

        <h4>Results</h4>
        <p className="content-p p-check">
          Updated the company’s design system, incl. fixing outdated elements,
          adding new components, removing duplicate components, and completing
          the foundation page.
        </p>
        <p className="content-p p-check">
          Created the UX playbook that’s been used by the UX team, CRO, and
          leadership.
        </p>
        <p className="content-p p-check">
          The design system and UX playbook cover all aspects of the design and
          research process in Assurant, and they guide the design team and
          contribute to shaping company strategies.
        </p>

        <h4>What I learned</h4>

        <p className="content-p">
          During my time at Assurant, I tackled intriguing problems that tested
          and honed multiple skills. The skills I improved the most were
          cross-team collaboration and communication. I worked closely with PMs,
          designers, and engineers and also interfaced with the leadership. This
          experience broadened my ability to navigate diverse perspectives,
          ensuring that all voices were heard and integrated into the design
          process. It taught me the importance of clear, consistent
          communication and the value of fostering strong working relationships
          across various departments.
        </p>
        <img
          className="img-responsive img-centered"
          src={WhatIlearned}
          alt=""
        />
      </div>
      <section className="mainSec">
        <img className="img-responsive img-centered" src={banner} alt="" />

        <img className="img-responsive img-centered" src={Audit} alt="" />
        <img className="img-responsive img-centered" src={Removing} alt="" />
        <img className="img-responsive img-centered" src={Foundations} alt="" />
        <img className="img-responsive img-centered" src={Color} alt="" />
        <img className="img-responsive img-centered" src={Auto} alt="" />
        <img className="img-responsive img-centered" src={Assets} alt="" />

        <img className="img-responsive img-centered" src={Icons} alt="" />
      </section>
    </section>
  </div>
);

export default Assurant;



// WEBPACK FOOTER //
// ./src/Modules/Case/Assurant.js